import React, { useState, useEffect } from 'react';
import request from '@/services/request.service';
import { useLocation } from 'react-router-dom';
import { toFormData } from '@/utils/convert.util';

import Box from './Box';
import Calendar from './Calender';
import TableTwo from './table/TableTwo';
import TableThree from './table/TableThree';
import TableFour from './table/TableFour';
import TableFive from './table/TableFive';
import TableSix from './table/TableSix';
import TableSeven from './table/TableSeven';
import { getLocaleWordContent } from '@/utils/language.util';

export default function BonusHistory() {
    const location = useLocation();
    const [tab, setTab] = useState('');
    const [title, setTitle] = useState('');
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [btype, setType] = useState('ROL');
    const [lst, setLst] = useState([]);
    const [total, setTotal] = useState();

    const param = location.search;

    const fetchBusinesses = () => {
        if (param === '?tab2') {
            setTab('tab2');
            setTitle(getLocaleWordContent('일일보너스'));
            setType('ALL');
            getList('ALL');
        } else if (param === '?tab3') {
            setTab('tab3');
            setTitle(getLocaleWordContent('롤업보너스'));
            setType('ROL');
            getList('ROL');
        } else if (param === '?tab4') {
            setTab('tab4');
            setTitle(getLocaleWordContent('추천수당'));
            setType('DB');
            getList('DB');
        } else if (param === '?tab5') {
            setTab('tab5');
            setTitle(getLocaleWordContent('센터수당'));
            setType('BB');
            getList('BB');
        } else if (param === '?tab6') {
            setTab('tab6');
            setTitle(getLocaleWordContent('직급수당'));
            setType('RB');
            getList('RB');
        } else if (param === '?tab7') {
            setTab('tab7');
            setTitle(getLocaleWordContent('투자금 및 판매수익합계'));
            setType('INVEST');
            getList('INVEST');
        }
        setStartDate();
        setEndDate();
    };
    useEffect(fetchBusinesses, [param]);

    const getList = async (btype) => {
        const param = { b_type: btype }; //
        const rsp = await request
            .post('/api/bonus/bonus_hist.php', toFormData(param))
            .then((response) => response.data);
        if (rsp.result < 0) {
            alert(rsp.msg);
            return rsp;
        } else {
            setLst(rsp.list);
            setTotal(rsp.total);
        }
    };

    return (
        <>
            <h2 className="inner text-center">{title}</h2>
            <div className="bg_balance_left">
                <Box />
                <div className="log_box log_history">
                    <h2 className="strong">{title}</h2>
                    <Calendar
                        btype={btype}
                        setLst={setLst}
                        startDate={startDate}
                        endDate={endDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                    />
                    {tab === 'tab2' ? <TableTwo history={lst} /> : null}
                    {tab === 'tab3' ? <TableThree history={lst} /> : null}
                    {tab === 'tab4' ? <TableFour history={lst} /> : null}
                    {tab === 'tab5' ? <TableFive history={lst} /> : null}
                    {tab === 'tab6' ? <TableSix history={lst} /> : null}
                    {tab === 'tab7' ? <TableSeven history={lst} /> : null}
                    <div className="bottom-btn text-center">
                        {tab === 'tab2' || tab === 'tab7' ? (
                            <div className="bottom-btn text-center">
                                <button className="b_orange btn02">{getLocaleWordContent('누적합계')}: {total || ''}</button>
                            </div>
                        ) : null}

                        {tab === 'tab3' || tab === 'tab4' || tab === 'tab5' || tab === 'tab6' ? (
                            <button className="b_orange btn02">{getLocaleWordContent('누적 합계금액')}  : {total || ''}</button>
                        ) : null}
                    </div>
                    <div className="sp15"></div>
                </div>
            </div>
        </>
    );
}
